import { useState, useCallback } from 'react';

interface ToastState {
  open: boolean;
  title?: string;
  description?: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  /** ms visible; omit to use ToastProvider default (5000) */
  duration?: number;
}

export const useToast = () => {
  const [toast, setToast] = useState<ToastState>({
    open: false,
    title: '',
    description: '',
    type: 'success'
  });

  const showToast = useCallback(
    (
      title: string,
      description?: string,
      type: 'success' | 'error' | 'warning' | 'info' = 'success',
      duration?: number,
    ) => {
      setToast({
        open: true,
        title,
        description,
        type,
        ...(duration != null ? { duration } : {}),
      });
    },
    [],
  );

  const hideToast = useCallback(() => {
    setToast(prev => ({ ...prev, open: false }));
  }, []);

  return {
    toast,
    showToast,
    hideToast
  };
}; 